import * as React from 'react';
import { Instagram } from 'react-content-loader';
import { StyledInstagram } from './InstagramLoader.styles';

export const InstagramLoader = () => (
  <StyledInstagram data-testid='instagram-loader'>
    <Instagram />
  </StyledInstagram>
);
